import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Layout from "./components/Layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import FileUploader from "./components/FileUploader";
import MyFiles from "./pages/MyFiles.jsx";
import AdminDashboard from "./pages/AdminDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Main from "./pages/Main";
import SetPassword from "./pages/setPassword";
import NomineeAccess from "./pages/NomineeAccess";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";

  function App() {
    const [token, setToken] = React.useState(localStorage.getItem("token"));
    const [user, setUser] = React.useState(() => {
      const savedUser = localStorage.getItem("user");
      if (!savedUser) return null;
      try {
        return JSON.parse(savedUser);
      } catch {
        // A corrupted/invalid value (e.g. the literal string "undefined",
        // which localStorage.setItem produces if ever handed a real
        // `undefined`) must not crash the whole app — this runs inside a
        // useState initializer on the very first render, with no error
        // boundary above it, so an uncaught throw here means #root never
        // mounts at all. Clear it so this doesn't repeat every reload.
        localStorage.removeItem("user");
        return null;
      }
    });
  
    const isAuthenticated = Boolean(token && user);
  
    const handleLogout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setToken(null);
      setUser(null);
    };
  return (
    <Router>
      <Routes>
        <Route element={<Layout onLogout={handleLogout} />}>
          {/* ---------- PUBLIC ---------- */}
          <Route
            path="/"
            element={
              isAuthenticated ? <Navigate to="/myfiles" replace /> : <Main />
            }
          />

          {/* Always the public landing page, even in an already-logged-in
              browser — unlike "/", which sends a logged-in session straight
              to /myfiles. Needed for links meant to show the marketing page
              regardless of session state (e.g. NomineeAccess's "Learn About
              ShadowVault", clicked by whoever has the share link, not
              necessarily whoever's logged in on that device). */}
          <Route path="/welcome" element={<Main />} />

          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/myfiles" replace />
              ) : (
                <Login setToken={setToken} setUser={setUser} />
              )
            }
          />

          <Route
            path="/register"
            element={
              isAuthenticated ? (
                <Navigate to="/myfiles" replace />
              ) : (
                <Register setToken={setToken} setUser={setUser} />
              )
            }
          />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/set-password/:token" element={<SetPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />

          {/* ---------- PROTECTED ---------- */}
          <Route
            path="/myfiles"
            element={
              isAuthenticated ? (
                <MyFiles token={token} user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/upload"
            element={
              isAuthenticated ? (
                <FileUploader token={token} user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/admin"
            element={
              isAuthenticated ? (
                <AdminDashboard token={token} user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          {/* ---------- FALLBACK ---------- */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>

        {/* Standalone — no header/footer, public nominee access */}
        <Route path="/nominee-access" element={<NomineeAccess />} />
      </Routes>
    </Router>
  );
}

export default App;
